import React from 'react';
import './BusinessHero.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAndroid } from '@fortawesome/free-brands-svg-icons';
import { faApple } from '@fortawesome/free-brands-svg-icons';


const BusinessHero = () => {

    return (
        // === Business page top section ===
        <div className="hero-section">
            {/* === Business Hero area === */}
            <div className="hero-content">
                <div className="container">
                    <div className="hero-main-content">
                        <div className="hero-main-left">
                            <h2 className="headding">Revolutionising the Party Industry!</h2>
                            <p className="description">The ultimate party app for your business. Increase exposure of your business through our platform and reach customers that matter most.</p>
                            <h4 className="btn-group-heading">GET THE APP ON</h4>
                            <div className="button-group">
                                <a href="https://play.google.com/store/apps/details?id=com.app.partyzuser&hl=en"><FontAwesomeIcon icon={faAndroid} /> Play Store</a>
                                <a href="https://apps.apple.com/au/app/elite-partyz/id1486807702" className="app-store"><FontAwesomeIcon icon={faApple} /> App Store</a>
                            </div>
                        </div>
                        <div className="hero-main-right">
                            <img src="/img/hero.webp" alt="App" />
                        </div>
                    </div>
                </div>
            </div>
            {/* === Background Curv style === */}
            <div className="background-curv" style={{ backgroundImage: `url('/img/bg-1.webp')` }}>
                <div className="hero-overlay">

                </div>
            </div>
        </div>
    )
}

export default BusinessHero
